<div [innerHTML]="content | safeHtml"></div>